import Phaser from "phaser";
import { CityScene } from "./scenes/CityScene.js";

export class MonsterGame {
  constructor({ parentId, audio, onHudChange, onStatus, onResult }) {
    this.parentId = parentId;
    this.audio = audio;
    this.onHudChange = onHudChange;
    this.onStatus = onStatus;
    this.onResult = onResult;
    this.game = null;
    this.activeMonsterId = null;
  }

  async start(monsterId, levelConfig = null) {
    this.activeMonsterId = monsterId;
    this.activeLevelConfig = levelConfig;
    await this.audio.unlock();

    if (this.game) {
      this.game.destroy(true);
      this.game = null;
    }

    const isMobile = !!this.joystickState
      || ('ontouchstart' in window || navigator.maxTouchPoints > 0)
      || window.innerWidth < window.innerHeight
      || window.innerWidth <= 768;
    const canvasWidth  = isMobile ? 540  : 1280;
    const canvasHeight = isMobile ? 900  : 780;

    const scene = new CityScene({
      monsterId,
      audio: this.audio,
      onHudChange: this.onHudChange,
      onStatus: this.onStatus,
      onResult: this.onResult,
      isMobile,
      joystickState: this.joystickState ?? null,
      levelConfig: levelConfig ?? null,
    });

    this.game = new Phaser.Game({
      type: Phaser.AUTO,
      parent: this.parentId,
      width: canvasWidth,
      height: canvasHeight,
      backgroundColor: "#081820",
      scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        width: canvasWidth,
        height: canvasHeight,
      },
      render: {
        antialias: true,
      },
      scene: [scene],
    });
  }

  restart() {
    if (!this.activeMonsterId) {
      return Promise.resolve();
    }

    return this.start(this.activeMonsterId, this.activeLevelConfig);
  }

  stop() {
    if (this.game) {
      this.game.destroy(true);
      this.game = null;
    }
    this.activeMonsterId = null;
    this.activeLevelConfig = null;
  }

  triggerAbility() {
    const scene = this.game?.scene.getScene('city-scene');
    if (scene) scene.triggerAbilityFromTouch();
  }

  triggerDash() {
    const scene = this.game?.scene.getScene('city-scene');
    if (scene) scene.triggerDashFromTouch();
  }

  setJoystickState(state) {
    this.joystickState = state;
  }
}